import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Attach Bearer token (fallback for browsers that don't send the auth cookie).
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("cb_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// On expired/invalid session, drop the token and bounce to login (never during auth calls).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err.config?.url || "";
    const onLogin = window.location.pathname.startsWith("/login");
    if (err.response?.status === 401 && !url.includes("/auth/")) {
      localStorage.removeItem("cb_token");
      if (!onLogin) window.location.assign("/login");
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
